import createReactClass from 'create-react-class';
import { useEffect, useState } from 'react';

export default function () {
  const html = (props) => {
    const general_needs = props?.globalState?.general_needs;
    const [numInsurences, setNumInsureces] = useState(0);

    useEffect(() => {
      setNumInsureces(general_needs?.length);
    }, [props]);

    useEffect(() => {
      props.field.state.value = numInsurences;
      props.onUpdate()
    }, [numInsurences]);

    return null;
  };

  return {
    html: html,
    config: {
      invisible: true,
    },
  };
}
